import { useQuery } from "@tanstack/react-query";
import { helpdeskApi, useHelpdeskKey, useHelpdeskMutation } from "./api";

/** Własny wybór pracownika: wypisanie się z codziennego raportu (konfiguracja raportu jest wspólna). */
export function ReportSubscription() {
	const key = useHelpdeskKey();
	const query = useQuery({
		queryKey: key("report-subscription"),
		queryFn: helpdeskApi.reportSubscription,
	});
	const save = useHelpdeskMutation(
		(subscribed: boolean) => helpdeskApi.setReportSubscription(subscribed),
		{
			success: (r) => (r.subscribed ? "Raport będzie przychodził" : "Wypisano z raportu"),
			error: "Nie udało się zapisać wyboru",
		},
	);
	return (
		<div className="max-w-3xl space-y-1 rounded-md border border-border bg-card p-3">
			<label className="flex items-center gap-2 text-sm font-medium">
				<input
					type="checkbox"
					// Zaznaczone przy ładowaniu (domyślnie każdy dostaje raport); odmowa — odznaczone.
					checked={!query.isError && (query.data?.subscribed ?? true)}
					disabled={!query.data || query.isError || save.isPending}
					onChange={(e) => save.mutate(e.target.checked)}
				/>
				Wysyłaj mi codzienny raport
			</label>
			<p className="text-[11px] text-muted-foreground">
				{query.error?.message ??
					"Tylko Twój wybór — inni pracownicy dostają swoje raporty bez zmian."}
			</p>
		</div>
	);
}
